import React, {useState, useEffect, useCallback} from "react";
import { Table, Form, Button, Container, Row, Col, Pagination } from "react-bootstrap";
import { fetchAuditLogs } from "../api/api";
// import { useUser } from "../UserContext";

const AuditLogPage = () => {
    // const { user } = useUser(); // can be used later if non admin users can view audit logs
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [ logs, setLogs ] = useState([]);
    const [ filters, setFilters ] = useState({
        action_done: '',
        model_name: '',
        start_date: '',
        end_date: ''
    });

    const loadAuditLogs = useCallback(async () => {
        try {
            const fetchedLogs = await fetchAuditLogs(filters, currentPage);
            setLogs(fetchedLogs.results);
            setTotalPages(Math.ceil(fetchedLogs.count / 20));
        } catch (error) {
            console.error('Error fetching audit logs:', error);
        }
    }, [filters, currentPage]);

    useEffect(() => {
        loadAuditLogs().then(r => r);
    }, [loadAuditLogs]);

    const handleFilterChange = (e) => {
        setFilters({...filters, [e.target.name]: e.target.value});
    };

    // const handlePageChange = (pageNumber) => {
    //     setCurrentPage(pageNumber);
    // };

    // color-code semantics
    const gerRowVariant = (action) => {
        switch (action) {
            case 'CREATE':
                return 'table-success';
            case 'UPDATE':
                return 'table-warning';
            case 'DELETE':
                return 'table-danger';
            case 'LOGIN':
                return 'table-info'
            case 'LOGOUT':
                return 'table-secondary';
            default:
                return '';
        }
    };

    const MAX_VISIBLE_PAGES = 5;

    const getVisiblePages = () => {
        let start = Math.max(1, currentPage - Math.floor(MAX_VISIBLE_PAGES / 2));
        let end = start + MAX_VISIBLE_PAGES - 1;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - MAX_VISIBLE_PAGES + 1);
        }
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    return (
        <Container>
            <h2>Audit Logs</h2>
            <Form>
                <Row>
                    <Col>
                        <Form.Group controlId="filterAction">
                            <Form.Label>Action</Form.Label>
                            <Form.Control as="select" name="action_done" value={filters.action_done} onChange={handleFilterChange}>
                                <option value="">All</option>
                                <option value="CREATE">Create</option>
                                <option value="UPDATE">Update</option>
                                <option value="DELETE">Delete</option>
                                <option value="LOGIN">Login</option>
                                <option value="LOGOUT">Logout</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="filterModelName">
                            <Form.Label>Model Name</Form.Label>
                            <Form.Control type="text" name="model_name" value={filters.model_name}
                                          onChange={handleFilterChange} placeholder="e.g, Customer" />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="filterStartDate">
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control type="date" name="start_date" value={filters.start_date} onChange={handleFilterChange} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="filterEndDate">
                            <Form.Label>End Date</Form.Label>
                            <Form.Control type="date" name="end_date" value={filters.end_date} onChange={handleFilterChange} />
                        </Form.Group>
                    </Col>
                    <Col className="d-flex align-items-end">
                        <Button variant="primary" onClick={loadAuditLogs}>Filter</Button>
                    </Col>
                </Row>
            </Form>
            <Table striped bordered hover className="mt-4">
                <thead>
                    <tr>
                        <th>User</th>
                        <th>Action</th>
                        <th>Model</th>
                        <th>Object ID</th>
                        <th>Timestamp</th>
                        <th>Summary</th>
                        <th>Changes</th>
                    </tr>
                </thead>
                <tbody>
                    {logs.map(log => (
                        <tr key={log.id} className={gerRowVariant(log.action_done)}>
                            <td>{log.user}</td>
                            <td>{log.action_done}</td>
                            <td>{log.model_name}</td>
                            <td>{log.object_id}</td>
                            <td>{new Date(log.timestamp).toLocaleString('en-GB', {
                                dateStyle: 'short',
                                timeStyle: 'medium'
                            })}</td>
                            <td>{log.summary}</td>
                            <td>{log.changes && (
                                <pre>{JSON.stringify(JSON.parse(log.changes), null, 2)}</pre>
                                // JSON.parse converts stringified JSON to JS object
                                // <pre> tag is used to preserve formatting
                            )}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Pagination className="justify-content-center">
                <Pagination.First
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(1)}
                />
                <Pagination.Prev
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                />
                {getVisiblePages().map(page => (
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </Pagination.Item>
                ))}

                <Pagination.Next
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                />
                <Pagination.Last
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(totalPages)}
                />
            </Pagination>
        </Container>
    );
};

export default AuditLogPage;